module.exports = __webpack_public_path__ + "media/images/title-6df8b3c63d8ea1a4d42ee5e985d22409.png";